import { themeColors } from '../../themeColors';
import BackButton from "@/components/Common/BackButton";
/**
 * @file   src\components\MemberWantAd\BottomNavBar.js
 * @brief  This file is responsible for bottom nav bar.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Button from "react-bootstrap/Button";

const BottomNavBar = (props) => {
  const {
    handleContinueClick,
    isDisabled,
    backButtonEnable,
    handleBackButtonClick,
    skipButtonEnable,
    handleSkipButtonClick,
    continueButtonText,
    step,
    bottomNavClass,
    backButtonText,
    hideContinueButton,
    isFinalStep,
    exitButtonDisable,
    handleSaveAndExit,
    exitButtonText,
  } = props;

  return (
    <div className={bottomNavClass || "btm-nav-bar"}>
      {backButtonEnable ? (
        <BackButton text={backButtonText || "Back"} onClick={() => handleBackButtonClick(step)} />
      ) : (
        ""
      )}

      <div className="btm-nav-btn-wrap ms-sm-auto">
        {skipButtonEnable ? (
          <Button
            variant="primary"
            className="btn-grey me-2"
            onClick={() => handleSkipButtonClick(step)}
          >
            Skip
          </Button>
        ) : isFinalStep && !exitButtonDisable ? (
          <Button
            variant="primary"
            className="btn-grey"
            onClick={() => handleSaveAndExit(step)}
          >
            {exitButtonText}
          </Button>
        ) : (
          ""
        )}{" "}
        {!hideContinueButton && (
          <Button
            variant="primary"
            className="ms-0 me-0"
            disabled={isDisabled}
            onClick={() => handleContinueClick(step)}
          >
            {continueButtonText || "Continue"}
          </Button>
        )}
      </div>
    </div>
  );
};
export default BottomNavBar;
